<template>
    <div class="bid-box">
        <table class="layui-table">
            <colgroup>
                <col width="150">
                <col width="200">
                <col width="200">
                <col width="150">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr v-for="(item,index) in stage1" :key="item.id">
                    <td>{{parseInt(index)+1}}</td>
                    <td rowspan="15" v-if="index==0">前期资料填报阶段</td>
                    <td>{{item.name}}</td>
                    <td>
                        <p v-if="edit" style="text-align: left;">
                            <el-checkbox v-model="item.flag">无</el-checkbox>
                        </p>
                         <p v-else style="text-align: left;">
                            <el-checkbox v-model="item.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td>
                        <div v-if="!item.flag" style="text-align: left;">
                            <el-upload
                                class="upload-demo"
                                style="display: flex;"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.key'
                                :on-success="handleSuccess"
                                :on-remove="handleDel"
                                :on-preview="showFile"
                                :file-list="item.list">
                             <el-button  v-if="edit"  size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>16</td>
                    <td rowspan="5">招标文件阶段</td>
                    <td>招标文件</td>
                    <td></td>
                    <td style="text-align: left;">
                        <el-upload
                            class="upload-demo"
                            style="display: flex;"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            :file-list="tender.tenderFile">
                            <el-button size="small" type="primary"  v-if="edit">点击上传</el-button>
                            
                        </el-upload>
                    </td>
                </tr>
                <tr>
                    <td>17</td>
                    <td>招标文件答疑</td>
                    <td>
                        <p v-if="edit" style="text-align: left;">
                            <el-checkbox v-model="tender.biddingFile.flag">无</el-checkbox>
                        </p>
                        <p v-else style="text-align: left;">
                            <el-checkbox v-model="tender.biddingFile.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td>
                        <div v-if="!tender.biddingFile.flag" style="text-align: left;">
                            <el-upload
                                class="upload-demo"
                                style="display: flex;"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess2"
                                :on-remove="handleDel2"
                                :on-preview="showFile"
                                :file-list="tender.biddingFile.list">
                                <el-button size="small" type="primary" v-if="edit" >点击上传</el-button>
                            </el-upload>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>18</td>
                    <td>清单</td>
                    <td>
                        <p v-if="edit" style="text-align: left;">
                         <el-checkbox v-model="tender.listPrice.flag">无</el-checkbox>
                        </p>
                        <p v-else style="text-align: left;">
                            <el-checkbox v-model="tender.listPrice.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td>
                        <div v-if="!tender.listPrice.flag" style="text-align: left;">
                            <el-upload
                                class="upload-demo"
                                style="display: flex;"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess3"
                                :on-remove="handleDel3"
                                :on-preview="showFile"
                                :file-list="tender.listPrice.list">
                                <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                            </el-upload>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>19</td>
                    <td>控制价（万元）</td>
                    <td>
                        <p v-if="edit" style="text-align: left;">
                            <el-checkbox v-model="tender.controlPrice.flag">无</el-checkbox>
                        </p>
                         <p v-else style="text-align: left;"> 
                            <el-checkbox v-model="tender.controlPrice.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <el-input v-if="!tender.controlPrice.flag&&edit" v-model="tender.controlPrice.val" placeholder="" style="margin-left:1vw;"></el-input>
                        <el-input v-if="!tender.controlPrice.flag&&!edit" v-model="tender.controlPrice.val" placeholder="" style="margin-left:1vw;" disabled></el-input>
                    </td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>投标文件</td>
                    <td>
                        <p v-if="edit" style="text-align: left;">
                            <el-checkbox v-model="tender.tenderBusiness.flag">无</el-checkbox>
                        </p>
                         <p v-else style="text-align: left;"> 
                            <el-checkbox v-model="tender.tenderBusiness.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td>
                        <div v-if="!tender.tenderBusiness.flag" style="text-align: left;">
                            <el-upload
                                class="upload-demo"
                                style="display: flex;"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess7"
                                :on-remove="handleDel7"
                                :on-preview="showFile"
                                :file-list="tender.tenderBusiness.list">
                                <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onTenderSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div>
        <!-- <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" width="100" label="序号"></el-table-column>
            <el-table-column prop="name" label="阶段" width="300">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="flow" label="流程" width="300">
                <template slot-scope="scope">
                    <span>{{scope.row.flow}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="flag" label="内容">
                <template slot-scope="scope">
                    <div v-if="scope.row.flag"></div>
                </template>
            </el-table-column>
        </el-table> -->
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
            <el-tab-pane label="前期资料填报" name="first">
                <el-form ref="form" :model="form" label-width="500px">
                    <el-form-item label="所属合同：">
                        <span style="color:#296dd3;">{{agreeName}}</span>
                    </el-form-item>
                    <el-form-item v-for="item in stage1" :key="item.id" :label="item.name">
                        <p v-if="edit">
                            <el-checkbox v-model="item.flag">无</el-checkbox>
                        </p>
                         <p v-else >
                            <el-checkbox v-model="item.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!item.flag">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.key'
                                :on-success="handleSuccess"
                                :on-remove="handleDel"
                                :on-preview="showFile"
                                :file-list="item.list">
                             <el-button  v-if="edit"  size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="edit">
                        <el-button type="primary" @click="onSubmit" >保存</el-button>
                        <el-button>返回</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane> -->

            <!-- 招标资料填报------------------------------------------------------ -->

            <!-- <el-tab-pane label="招标资料填报" name="second">
                <el-form ref="form" :model="tender" label-width="500px">
                    <el-form-item label="所属合同：">
                        <span>{{agreeName}}</span>
                    </el-form-item>
                    <el-form-item label="招标类型：">
                        <el-select v-model="tender.tenderType.val" placeholder="请选择" v-if="edit">
                            <el-option label="货物招标投标" value="1"></el-option>
                            <el-option label="工程招标投标" value="2"></el-option>
                            <el-option label="服务招标投标" value="3"></el-option>
                            <el-option label="其他" value="4"></el-option>
                        </el-select>
                         <el-select v-model="tender.tenderType.val" placeholder="请选择" v-else>
                            <el-option label="货物招标投标" value="1" disabled></el-option>
                            <el-option label="工程招标投标" value="2" disabled></el-option>
                            <el-option label="服务招标投标" value="3" disabled></el-option>
                            <el-option label="其他" value="4" disabled></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="招标方式：">
                        <el-select v-model="tender.tenderMode.val" placeholder="请选择" v-if="edit">
                            <el-option label="公开招标" value="1"></el-option>
                            <el-option label="邀请招标" value="2"></el-option>
                            <el-option label="竞争性谈判" value="3"></el-option>
                            <el-option label="单一来源谈判" value="4"></el-option>
                            <el-option label="直接委托" value="5"></el-option>
                            <el-option label="其他" value="6"></el-option>
                        </el-select>
                        <el-select v-model="tender.tenderMode.val" placeholder="请选择" v-else>
                            <el-option label="公开招标" value="1" disabled></el-option>
                            <el-option label="邀请招标" value="2" disabled></el-option>
                            <el-option label="竞争性谈判" value="3" disabled></el-option>
                            <el-option label="单一来源谈判" value="4" disabled></el-option>
                            <el-option label="直接委托" value="5" disabled></el-option>
                            <el-option label="其他" value="6" disabled></el-option>
                        </el-select>
                        <el-input v-if="edit"  v-model="tender.modeName" class="rightMar" placeholder="备注"></el-input>
                        <el-input v-else  v-model="tender.modeName" class="rightMar"  disabled  placeholder="备注"></el-input>
                    </el-form-item>
                    <el-form-item label="招标级别：">
                        <el-select v-model="tender.tenderLevel.val" placeholder="请选择" v-if="edit">
                            <el-option label="市级" value="1"></el-option>
                            <el-option label="区级" value="2"></el-option>
                        </el-select>
                        <el-select v-model="tender.tenderLevel.val" placeholder="请选择" v-else>
                            <el-option label="市级" value="1" disabled></el-option>
                            <el-option label="区级" value="2" disabled></el-option>
                        </el-select>
                        <el-input v-if="edit" v-model="tender.levelName" class="rightMar" placeholder="备注"></el-input>
                        <el-input v-else v-model="tender.levelName" class="rightMar" placeholder="备注" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="招标编号：">
                        <el-input v-if="edit"   v-model="tender.tenderNo" placeholder=""></el-input>
                        <el-input v-else  v-model="tender.tenderNo" disabled  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="招标代理机构：">
                        <el-input  v-if="edit"  v-model="tender.agentDeptName" placeholder=""></el-input>
                         <el-input v-else  v-model="tender.agentDeptName" placeholder="" disabled></el-input>
                        <span class="tit">招标代理负责人：</span>
                        <el-input v-if="edit"  v-model="tender.agentHeadName" placeholder=""></el-input>
                        <el-input v-else  v-model="tender.agentHeadName" placeholder="" disabled></el-input>
                        <span class="tit">招标代理负责人电话：</span>
                        <el-input v-if="edit" v-model="tender.agentHeadPhone" placeholder=""></el-input>
                        <el-input v-else v-model="tender.agentHeadPhone" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="招标文件、答疑、补疑、招标文件评审表及参评人员审批表扫描件：">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            :file-list="tender.tenderFile">
                            <el-button size="small" type="primary"  v-if="edit">点击上传</el-button>
                            
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="评标方法：">
                        <el-input v-if="edit" v-model="tender.evaluationMethod" placeholder=""></el-input>
                        <el-input v-else  v-model="tender.evaluationMethod" placeholder="" disabled></el-input>
                        <span class="tit">招标代理负责人电话：</span>
                        <el-input v-if="edit" v-model="tender.participants" placeholder=""></el-input>
                        <el-input v-else v-model="tender.participants" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="招标方式依据文件：">
                       <p v-if="edit">
                            <el-checkbox v-model="tender.biddingFile.flag">无</el-checkbox>
                        </p>
                        <p v-else>
                            <el-checkbox v-model="tender.biddingFile.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.biddingFile.flag">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess2"
                                :on-remove="handleDel2"
                                :on-preview="showFile"
                                :file-list="tender.biddingFile.list">
                                <el-button size="small" type="primary" v-if="edit" >点击上传</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="清单编制单位：">
                        <p  v-if="edit">
                            <el-checkbox v-model="tender.listDeptName.flag">无</el-checkbox>
                        </p>
                        <p  v-else>
                            <el-checkbox v-model="tender.listDeptName.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.listDeptName.flag">
                            <div v-for="(item,index) in tender.listDeptName.list" :key="index" style="display:flex;">
                                <p style="display: flex;width: 33%;">单位名称：
                                    <el-input v-if="edit"  v-model="item.name" placeholder=""></el-input>
                                    <el-input v-else  v-model="item.name" placeholder="" disabled></el-input>
                                </p>
                                <p style="display: flex;width: 33%;">负责人：
                                    <el-input v-if="edit" v-model="item.person" placeholder=""></el-input>
                                    <el-input v-else v-model="item.person" placeholder="" disabled></el-input>
                                </p>
                                <p style="display: flex;width: 33%;">电话：
                                    <el-input v-if="edit"  v-model="item.phone" placeholder=""></el-input>
                                    <el-input v-else v-model="item.phone" placeholder="" disabled></el-input>
                                </p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="清单及控制价：">
                        <p v-if="edit">
                         <el-checkbox v-model="tender.listPrice.flag">无</el-checkbox>
                        </p>
                        <p v-else>
                            <el-checkbox v-model="tender.listPrice.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.listPrice.flag">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess3"
                                :on-remove="handleDel3"
                                :on-preview="showFile"
                                :file-list="tender.listPrice.list">
                                <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="招标公告：">
                        <p v-if="edit">
                            <el-checkbox v-model="tender.tenderNotice.flag">无</el-checkbox>
                        </p>
                         <p v-else>
                            <el-checkbox v-model="tender.tenderNotice.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.tenderNotice.flag">
                            <p v-for="(item,index) in tender.tenderNotice.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.val"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else
                                    v-model="item.val"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled>
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess4"
                                    :on-remove="handleDel4"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddNotice" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex==index" class="el-icon-delete ctl" @click="delNotice(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </p>
                        </div>
                    </el-form-item>
                    <el-form-item label="中标公告：">
                        <p v-if="edit">
                            <el-checkbox v-model="tender.winNotice.flag">无</el-checkbox>
                        </p>
                        <p v-else>
                            <el-checkbox v-model="tender.winNotice.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.winNotice.flag">
                            <p v-for="(item,index) in tender.winNotice.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.val"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                 <el-date-picker
                                    v-else
                                    v-model="item.val"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    >
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess5"
                                    :on-remove="handleDel5"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toAddWinNotice" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex1==index" class="el-icon-delete ctl" @click="delWinNotice(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </p>
                        </div>
                    </el-form-item>
                    <el-form-item label="中标单位：">
                        <el-input v-if="edit"  v-model="tender.selectDept" placeholder=""></el-input>
                        <el-input v-else v-model="tender.selectDept" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="合同开工时间：">
                        <el-date-picker
                            v-if="edit"
                            v-model="tender.contractStartDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker
                            v-else
                            v-model="tender.contractStartDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="合同竣工时间：">
                        <el-date-picker
                            v-if="edit"
                            v-model="tender.contractEndDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                         <el-date-picker
                            v-else
                            v-model="tender.contractEndDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="合同工期：">
                        <el-input v-if="edit" v-model="tender.contractTime" placeholder=""></el-input>
                        <el-input v-else v-model="tender.contractTime" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="中标通知书：">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :on-success="handleSuccess6"
                            :on-remove="handleDel6"
                            :on-preview="showFile"
                            :file-list="tender.selectBook.list">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="投标文件（商务标）：">
                        <p v-if="edit">
                            <el-checkbox v-model="tender.tenderBusiness.flag">无</el-checkbox>
                        </p>
                         <p v-else> 
                            <el-checkbox v-model="tender.tenderBusiness.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.tenderBusiness.flag">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess7"
                                :on-remove="handleDel7"
                                :on-preview="showFile"
                                :file-list="tender.tenderBusiness.list">
                                <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="投标文件（技术标）：">
                        <p v-if="edit"> 
                            <el-checkbox v-model="tender.tenderTechno.flag">无</el-checkbox>
                        </p>
                         <p  v-else>
                            <el-checkbox v-model="tender.tenderTechno.flag" disabled>无</el-checkbox>
                        </p>
                        <div v-if="!tender.tenderTechno.flag">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :on-success="handleSuccess8"
                                :on-remove="handleDel8"
                                :on-preview="showFile"
                                :file-list="tender.tenderTechno.list">
                                <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同名称（合同及评审页扫描件）：">
                        <div v-for="(item,index) in tender.contract.list" :key="index" style="display:flex;margin-top:2vh;"  @mouseleave="delIndex2='-1'" @mouseenter="delIndex2=index">
                            <el-input v-if="edit" v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                            <el-input v-else v-model="item.val" placeholder="" style="margin-right:1vw;" disabled></el-input>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.index'
                                :on-success="handleSuccess9"
                                :on-remove="handleDel9"
                                :on-preview="showFile"
                                :file-list="item.files">
                                <el-button size="small" v-if="edit"  type="primary">点击上传</el-button>
                            </el-upload>
                            <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddContract" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                            <i v-if="edit" v-show="delIndex2==index" class="el-icon-delete ctl" @click="delContract(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同签订时间：">
                        <el-input v-if="edit" v-model="tender.contractDate" placeholder=""></el-input>
                        <el-input v-else v-model="tender.contractDate" placeholder="" disabled></el-input>
                        <span style="margin-left:1vw;">合同编号：</span>
                        <el-input v-if="edit" v-model="tender.contractNo" placeholder=""></el-input>
                        <el-input v-else v-model="tender.contractNo" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="控制价（万元）：">
                        <el-checkbox  v-if="edit" v-model="tender.controlPrice.flag">无</el-checkbox>
                        <el-checkbox v-if="edit" v-model="tender.controlPrice.flag" disabled>无</el-checkbox>
                        <el-input v-if="!tender.controlPrice.flag&&edit" v-model="tender.controlPrice.val" placeholder="" style="margin-left:1vw;"></el-input>
                        <el-input v-if="!tender.controlPrice.flag&&!edit" v-model="tender.controlPrice.val" placeholder="" style="margin-left:1vw;" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="中标价（万元）\中标费率%：">
                        <el-checkbox v-if="edit" v-model="tender.selectPrice.flag">无</el-checkbox>
                        <el-checkbox v-if="edit" v-model="tender.selectPrice.flag" disabled>无</el-checkbox>
                        <el-input v-if="!tender.selectPrice.flag&&edit" v-model="tender.selectPrice.val" placeholder="" style="margin-left:1vw;"></el-input>
                        <el-input v-if="!tender.selectPrice.flag&&!edit" v-model="tender.selectPrice.val" placeholder="" style="margin-left:1vw;" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="合同价（万元）：">
                        <el-input v-if="edit" v-model="tender.contractPrice" placeholder=""></el-input>
                        <el-input v-else v-model="tender.contractPrice" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="工程款支付比例：">
                        <el-input v-if="edit" v-model="tender.engineeringMoney" placeholder=""></el-input>
                        <el-input v-else v-model="tender.engineeringMoney" placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-checkbox  v-if="edit" v-model="tender.remarks.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="tender.remarks.flag" disabled>无</el-checkbox>
                        <el-input v-if="!tender.remarks.flag&&edit" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="tender.remarks.val"></el-input>
                        <el-input v-if="!tender.remarks.flag&&!edit" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="tender.remarks.val" disabled></el-input>

                    </el-form-item>
                    <el-form-item label="其他：">
                        <el-checkbox v-if="edit" v-model="tender.otherFile.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="tender.otherFile.flag" disabled>无</el-checkbox>
                        <div v-if="!tender.otherFile.flag">
                            <div v-for="(item,index) in tender.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-input v-if="edit" v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input v-else v-model="item.val" placeholder="" style="margin-right:1vw;" disabled></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess10"
                                    :on-remove="handleDel10"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddOtherFile" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delOtherFile(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item v-if="edit">
                        <el-button type="primary" @click="onTenderSubmit">保存</el-button>
                        <el-button>返回</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs> -->
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import stage from '../../untils/agree'
import base from '../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            activeName:'first',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
              accessToken: util.session.get('token')
            },
            form:{
                name:'',
            },
            stage1:stage.preFile,
            agreeName:'',
            tender:{
                // tenderType:{ //招标类型
                //     val:'',
                //     name:'',
                // },
                // tenderMode:{ //招标方式
                //     val:'',
                //     name:'',
                // },
                // modeName:'', //招标方式 ： 备注
                // tenderLevel:{ //招标级别
                //     val:'',
                //     name:'',
                // },
                // levelName:'', //招标级别 :备注
                // tenderNo:'', //招标编号
                // agentDeptName:'', //招标代理机构
                // agentHeadName:'', //招标代理负责人
                // agentHeadPhone:'',//招标代理负责人电话
                tenderFile:[], //招标文件、答疑、补疑、招标文件评审表及参评人员审批表扫描件
                // evaluationMethod:'', //评标方法
                // participants:'',  //参评人员
                biddingFile:{  //招标方式依据文件 
                    flag:false,
                    list:[],
                },
                // listDeptName:{ //清单编制单位
                //     flag:false,
                //     list:[
                //         {val:'',person:'',phone:''}
                //     ],
                // },
                listPrice:{ //清单及控制价
                    flag:false,
                    list:[],
                },
                // tenderNotice:{ //招标公告
                //     flag:false,
                //     list:[
                //         {val:'',files:[],index:1} //index 用于区分list
                //     ],
                // },
                // winNotice:{ //中标公告
                //     flag:false,
                //     list:[
                //         {val:'',files:[],index:1} //index 用于区分list
                //     ],
                // },
                // selectDept:'', //中标单位
                // contractStartDate:'',//合同开工时间
                // contractEndDate:'',//合同竣工时间
                // contractTime:'',//合同工期
                // selectBook:{list:[]}, //中标通知书
                tenderBusiness:{ //投标文件（商务标）
                    flag:false,
                    list:[]
                },
                // tenderTechno:{ //投标文件（技术标）
                //     flag:false,
                //     list:[]
                // },
                // contract:{ //合同名称（合同及评审页扫描件）
                //     list:[
                //         {val:'',files:[],index:1,} //index 用于区分list
                //     ],
                // },
                // contractDate:'', //合同签订时间
                // contractNo:'', //合同编号
                controlPrice:{//控制价（万元）
                    flag:false,
                    val:''
                },
                // selectPrice:{//中标价（万元）\中标费率%
                //     flag:false,
                //     val:''
                // },
                // contractPrice:'', //合同价（万元）
                // engineeringMoney:'',//工程款支付比例
                // remarks:{
                //     flag:false,
                //     val:''
                // },
                otherFile:{ //
                    flag:false,
                    list:[
                        {val:'',files:[],index:1,} //index 用于区分list
                    ],
                },
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex2:'-1',
            delIndex3:'-1',
            options:[],
            status:'',
            unitKind:'',
            edit:false,

        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        util.session.set('contractId',params.id)
        this.id = params.id
        this.status = params.status
        var that = this
        that.getInfo() //获取
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.getData()
                    // that.getData1()
                }
            })
        },
        //获取前期资料
        getData(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                // unitKind:this.unitKind,
                status:this.status,
                // flag:'0'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var i=0;i<that.stage1.length;i++){
                            if(data[that.stage1[i].key]){
                                that.stage1[i].list = JSON.parse(data[that.stage1[i].key])
                            }else{
                                that.stage1[i].flag = true
                            }
                        }
                        for(var item in that.tender){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.tender[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.tender[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.tender[item] = data[item]
                            }
                        }
                    }
                }
            })
        },
        //获取招标资料
        getData1(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'1'
            }).then(function(resp){
                
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var item in that.tender){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.tender[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.tender[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.tender[item] = data[item]
                            }
                        }
                    }
                    // console.log(that.tender)
                }
            })
        },
        //切换tab
        tabClick(tab, event){
            // console.log(tab, event);
        },
        //监听上传文件
        handleChange(file){
            
        },
        //上传文件成功
        handleSuccess(res, file,opt,other){
            if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    key:other
                }
                this.setUpload(other,obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel(file){
            this.delUpload(file)
        },
        //保存
        // onSubmit(){
        //     var list = this.stage1
        //     var data = {}
        //     var columnName = ''
        //     for(var i=0;i<list.length;i++){
        //         if(!list[i].flag){
        //             data[list[i].key] = list[i].list
        //             columnName = columnName==''?list[i].key:columnName+','+list[i].key
        //         }
        //     }
        //     data['contractId'] = this.id
        //     var opt = {
        //         contractId:this.id,
        //         unitKind:this.unitKind,
        //         status:this.status,
        //         flag:'0',
        //         columnName:columnName,
        //         type:8,
        //         entity:JSON.stringify(data),
        //         updateBy:util.session.get('user').id
        //     }
        //     var that = this
        //     myHttp.createOrupdate(opt).then(function(resp){
        //         if(resp.data.code=='200'){
        //             that.$message.success('保存成功');
        //             that.$store.commit('setRefrshAgree',true)
        //         }else{
        //             that.$message.error(resp.msg);
        //         }
        //     })
        // },
        //保存上传文件
        setUpload(str,obj){
            for(var i=0;i<this.stage1.length;i++){
                if(this.stage1[i].key == str){
                    this.stage1[i].list.push(obj)
                }
            }
        },
        //删除上传文件
        delUpload(obj){
            for(var i=0;i<this.stage1.length;i++){
                if(this.stage1[i].key == obj.key){
                    for(var j=0;j<this.stage1[i].list.length;j++){
                        this.stage1[i].list.splice(j,1)
                    }
                }
            }
        },

        /*************招标资料**************************************************** */
        //招标文件、答疑、补疑、招标文件评审表及参评人员审批表扫描件
        handleSuccess1(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.tenderFile.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file){
            for(var i=0;i<this.tender.tenderFile.length;i++){
                if(this.tender.tenderFile[i].uid==file.uid){
                    this.tender.tenderFile.splice(i,1)
                }
            }
        },
        //招标方式依据文件
        handleSuccess2(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.biddingFile.list.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file){
            for(var i=0;i<this.tender.biddingFile.list.length;i++){
                if(this.tender.biddingFile.list[i].uid==file.uid){
                    this.tender.biddingFile.list.splice(i,1)
                }
            }
        },
        //清单及控制价  listPrice
        handleSuccess3(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.listPrice.list.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel3(file){
            for(var i=0;i<this.tender.listPrice.list.length;i++){
                if(this.tender.listPrice.list[i].uid==file.uid){
                    this.tender.listPrice.list.splice(i,1)
                }
            }
        },
        //招标公告
        handleSuccess4(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.tender.tenderNotice.list.length;i++){
                    if(this.tender.tenderNotice.list[i].index==other){
                        this.tender.tenderNotice.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel4(file){
            for(var i=0;i<this.tender.tenderNotice.list.length;i++){
                if(this.tender.tenderNotice.list[i].index==file.index){
                    for(var j=0;j<this.tender.tenderNotice.list[i].files.length;j++){
                        this.tender.tenderNotice.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //中标公告
        handleSuccess5(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.tender.winNotice.list.length;i++){
                    if(this.tender.winNotice.list[i].index==other){
                        this.tender.winNotice.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel5(file){
            for(var i=0;i<this.tender.winNotice.list.length;i++){
                if(this.tender.winNotice.list[i].index==file.index){
                    for(var j=0;j<this.tender.winNotice.list[i].files.length;j++){
                        this.tender.winNotice.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //中标通知书
        handleSuccess6(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.selectBook.list.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel6(file){
            for(var i=0;i<this.tender.selectBook.list.length;i++){
                if(this.tender.selectBook.list[i].uid==file.uid){
                    this.tender.selectBook.list.splice(i,1)
                }
            }
        },
        //投标文件（商务标）
        handleSuccess7(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.tenderBusiness.list.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel7(file){
            for(var i=0;i<this.tender.tenderBusiness.list.length;i++){
                if(this.tender.tenderBusiness.list[i].uid==file.uid){
                    this.tender.tenderBusiness.list.splice(i,1)
                }
            }
        },
        //投标文件（技术标）
        handleSuccess8(res, file,opt){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls
                }
                this.tender.tenderTechno.list.push(obj)
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel8(file){
            for(var i=0;i<this.tender.tenderTechno.list.length;i++){
                if(this.tender.tenderTechno.list[i].uid==file.uid){
                    this.tender.tenderTechno.list.splice(i,1)
                }
            }
        },
        //合同名称（合同及评审页扫描件）
        handleSuccess9(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.tender.contract.list.length;i++){
                    if(this.tender.contract.list[i].index==other){
                        this.tender.contract.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel9(file){
            for(var i=0;i<this.tender.contract.list.length;i++){
                if(this.tender.contract.list[i].index==file.index){
                    for(var j=0;j<this.tender.contract.list[i].files.length;j++){
                        this.tender.contract.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //其他
        handleSuccess10(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.tender.otherFile.list.length;i++){
                    if(this.tender.otherFile.list[i].index==other){
                        this.tender.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel10(file){
            for(var i=0;i<this.tender.otherFile.list.length;i++){
                if(this.tender.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.tender.otherFile.list[i].files.length;j++){
                        this.tender.otherFile.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //添加招标公告
        toAddNotice(){
            var length = this.tender.tenderNotice.list.length
            var ind = this.tender.tenderNotice.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.tender.tenderNotice.list.push(obj)
        },
        delNotice(index){
            this.tender.tenderNotice.list.splice(index,1)
            if(this.tender.tenderNotice.list.length==0){
                var obj = {
                    time:'',files:[],index:1
                }
                this.tender.tenderNotice.list.push(obj)
            }
        },
        //添加中标公告 winNotice
        toAddWinNotice(){
            var length = this.tender.winNotice.list.length
            var ind = this.tender.winNotice.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.tender.winNotice.list.push(obj)
        },
        delWinNotice(index){
            this.tender.winNotice.list.splice(index,1)
            if(this.tender.winNotice.list.length==0){
                var obj = {
                    time:'',files:[],index:1
                }
                this.tender.winNotice.list.push(obj)
            }
        },
        //合同名称（合同及评审页扫描件）
        toAddContract(){
            var length = this.tender.contract.list.length
            var ind = this.tender.contract.list[length-1].index
            var obj = {
                name:'',files:[],index:parseInt(ind)+1
            }
            this.tender.contract.list.push(obj)
        },
        delContract(index){
            this.tender.contract.list.splice(index,1)
            if(this.tender.contract.list.length==0){
                var obj = {
                    name:'',files:[],index:1
                }
                this.tender.contract.list.push(obj)
            }
        },
        //其他
        toAddOtherFile(){
            var length = this.tender.otherFile.list.length
            var ind = this.tender.otherFile.list[length-1].index
            var obj = {
                name:'',files:[],index:parseInt(ind)+1
            }
            this.tender.otherFile.list.push(obj)
        },
        delOtherFile(index){
            this.tender.otherFile.list.splice(index,1)
            if(this.tender.otherFile.list.length==0){
                var obj = {
                    name:'',files:[],index:1
                }
                this.tender.otherFile.list.push(obj)
            }
        },
        //解析list数据
        filterNull(data){
            var listNull = false
            for(var obj in data[0]){
                if(obj!='index'){
                    if(typeof data[0][obj]=='string' && data[0][obj]!=''){
                        listNull = true
                    }else if(Array.isArray(data[0][obj]) && data[0][obj].length>0){
                        listNull = true
                    }
                }
            }
            if(!listNull){
                data = []
            }
            return data
        },
        //提交
        onTenderSubmit(){
            //前期资料填报阶段
            var list = this.stage1
            var data1 = {}
            var columnName = ''
            for(var i=0;i<list.length;i++){
                if(!list[i].flag){
                    data1[list[i].key] = list[i].list
                    columnName = columnName==''?list[i].key:columnName+','+list[i].key
                }
            }
            // data['contractId'] = this.id
            // var opt = {
            //     contractId:this.id,
            //     unitKind:this.unitKind,
            //     status:this.status,
            //     flag:'0',
            //     columnName:columnName,
            //     type:8,
            //     entity:JSON.stringify(data),
            //     updateBy:util.session.get('user').id
            // }

            var data = JSON.parse(JSON.stringify(this.tender))//this.tender
            for(var item in data){
                if(!data[item]||!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
                for(var obj in data[item]){
                    if(obj=='list' && data[item][obj].length==1){
                        data[item][obj]=this.filterNull(data[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data[item][obj]==''){
                            delete data[item][obj]
                        }
                    }
                }
            }
            for(var str in data1){
                data[str] = data1[str]
            }
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                // flag:'1',
                columnName:columnName,
                // type:9,
                entity:JSON.stringify(data),
                updateBy:util.session.get('user').id
            }
            var that = this
            myHttp.createOrupdateContract(opt).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('保存成功');
                    that.$store.commit('setRefrshAgree',true)
                }else{
                    that.$message.error(resp.msg);
                }
            })
        },
        //展示地址
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },

    },
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .upload-demo{
        min-width: 10vw;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box .el-upload-list{
        flex: 1;
    }
    .bid-box .el-upload-list__item{
        margin: 0;
        width: 50%;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-upload-list__item-name{
        height: 27px;
        display: flex;
        align-items: center;
    }
    .bid-box .el-icon-document{
        top: -5px;
    }
    .bid-box .el-form-item__content .rightMar{
        margin-left: 1vw;
    }
    .bid-box .el-form-item__content .tit{
        padding-left: 2vw;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
    }
    .layui-table td{
        font-size: inherit;
        text-align: center;
        line-height: 30px;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>